import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import moment from "moment";

const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";
const BASER_URL = '/master'
const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};

export const fetchhsnCodes = createAsyncThunk(
  "hsn-code/fetchhsnCodes",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters && filters.length > 0) {
      // params.append("filters", JSON.stringify(filters));
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              // Handle cases like { from_date: ..., to_date: ... }
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params.append(key, String(value));
                }
                if (
                  (filterValue.from_date || filterValue.to_date) &&
                  (filterField === "created_at" || filterField === "updated_at")
                ) {
                  if (filterField === "created_at") {
                    filterField = "created";
                  } else {
                    filterField = "updated";
                  }
                  params.append("filter_by", filterField);
                }
              });
            } else {
              // Handle primitive values (string, number)
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }
    const response: any = await Axios.get(`${BASER_URL}/hsn/?${params.toString()}`);
    return {
      data: response.data.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const fetchhsnCodeById = createAsyncThunk(
  "hsn-code/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(`${BASER_URL}/hsn/${id}/get/`);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch GST by ID");
    }
  }
);

export const fetchHsnCodeByDropDown = createAsyncThunk(
  "HsnCode/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${BASER_URL}/hsn/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch HsnCode list"
      );
    }
  }
);

export const updatehsnCode = createAsyncThunk(
  "hsn-code/updatehsnCode",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(`${BASER_URL}/hsn/${data.id}/update/`, data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update HsnCode");
    }
  }
);

export const updateStatusInhsnCode = createAsyncThunk(
  "hsn-code/updateStatusInhsnCode",
  async (data: any, { rejectWithValue }) => {
    try {
      const payload = { is_active: data.is_active };
      const response: any = await Axios.patch(
        `${BASER_URL}/hsn/${data.id}/update/`,
        payload
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update status in  HsnCode"
      );
    }
  }
);

export const addhsnCode = createAsyncThunk(
  "hsn-code/addhsnCode",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(`${BASER_URL}/hsn/create/`, data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add HsnCode");
    }
  }
);

export const deletehsnCode = createAsyncThunk(
  "hsn-code/delete",
  async (id: number, { rejectWithValue }) => {
    try {
      await Axios.delete(`${BASER_URL}/hsn/${id}/`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// export const exportHsnCodeCSV = async () => {
//   const response = await Axios.get("/hsn/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "hsncode.csv",
//   };
// };

export const exportHsnCodeCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  try {
    const params: any = {};

    if (search) {
      params.search = search;
    }

    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (filterField && filterValue !== undefined && filterValue !== null) {
            if (typeof filterValue === "object" && filterValue !== null) {
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params[key] = String(value);
                }
                if (
                  (filterValue.from_date || filterValue.to_date) &&
                  (filterField === "created_at" || filterField === "updated_at")
                ) {
                  if (filterField === "created_at") {
                    filterField = "created";
                  } else {
                    filterField = "updated";
                  }
                  params.filter_by = filterField;
                }
              });
            } else {
              params[filterField] = filterValue;
            }
          }
        }
      );
    }

    // Try to get CSV blob first
    try {
      const response = await Axios.get(`${BASER_URL}/hsn/export/`, {
        params,
        responseType: "blob",
      });

      return {
        blob: response.data,
        filename: `HSN_Code_List_${moment().format("YYYY-MM-DD")}.csv`,
      };
    } catch (blobError) {
      // If blob export fails, try JSON and convert to CSV
      const response = await Axios.get(`${BASER_URL}/hsn/`, {
        params: { ...params, export: "excel" },
      });

      const data = response.data?.data || response.data || [];

      // Convert JSON to CSV
      if (data.length === 0) {
        throw new Error("No data to export");
      }

      // Define CSV headers based on HSN Code structure
      const headers = [
        "Sr No.",
        "HSN Code",
        "HSN Code Description",
        "GST%",
        "Status",
        "Created By",
        "Created Date",
        "Updated By",
        "Updated Date",
      ];

      // Convert data to CSV rows
      const csvRows = [
        headers.join(","),
        ...data.map((hsn: any, index: number) => {
          const row = [
            hsn.sr_no || index + 1,
            hsn.hsn_code || "",
            hsn.description || "",
            hsn.gst_percent?.gst_percent ? `${hsn.gst_percent.gst_percent}%` : "",
            hsn.is_active ? "Active" : "Inactive",
            hsn.created_by_user?.username || hsn.created_by || "",
            hsn.created_at ? moment(hsn.created_at).format("DD/MM/YYYY") : "",
            hsn.updated_by_user?.username || hsn.updated_by || "",
            hsn.updated_at ? moment(hsn.updated_at).format("DD/MM/YYYY") : "",
          ];
          // Escape commas and quotes in CSV
          return row.map((cell) => {
            const cellStr = String(cell || "");
            if (cellStr.includes(",") || cellStr.includes('"') || cellStr.includes("\n")) {
              return `"${cellStr.replace(/"/g, '""')}"`;
            }
            return cellStr;
          }).join(",");
        }),
      ];

      const csvContent = csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

      return {
        blob,
        filename: `HSN_Code_List_${moment().format("YYYY-MM-DD")}.csv`,
      };
    }
  } catch (error: any) {
    throw new Error(error.response?.data?.message || error.message || "Failed to export HSN Code");
  }
};
